import React, { useState, useEffect} from 'react';
import { Tooltip, Image as AntdImage, Divider } from 'antd';
import { useDispatch, useSelector } from "react-redux";

import "./index.scss";
import Api from '../../../../../api'
import Iconfont from "../../../../../components/Iconfont/Iconfont";
import RightArrow from "../../../../../assets/img/V7/rightArrow.png";
import RightArrowBlack from "../../../../../assets/img/V7/rightArrowBlack.png";
import { setAIModalState } from "../../../../../features/AIIntelligentV7/AIReducer";
import KnowledgeFileIconV7 from "../../../../../components/KnowledgeFileIconV7";
import {goKnowledgeDetails} from '../../../../../utils/tool'
const LatestContent = () => {
    const dispatch = useDispatch();

    // 查询数据
    const [searchData, setSearchData] = useState({
        "pageIndex": 1,
        "pageSize": 3
    });
    // 分页
    const [pagination, setPagination] = useState({
        "pageIndex": 0,
        "pageSize": 0,
        "total":0,
        'totalPage': 0
    });

    const [dataList, setDataList] = useState([]);
    
    useEffect(()=>{
        getInitDate();
    },[searchData])
    const getInitDate = async() => {
        let res = await Api.Home.getNewKnowledge({data:searchData}); 
        if(res && res.code === 0 && res.data && res.data.records){
            let _records = res.data.records;
            for(let i=0; i<_records.length; i++){
                let userList = _records[i].knowledgeUserRelVOList;
                let userText = []
                for(let j=0; j<userList.length; j++){
                    userText.push(userList[j].userName)
                }
                _records[i].authors = userText
            }
            setPagination({
                "pageIndex": res.data.current,
                "pageSize": res.data.size,
                "total":res.data.total,
                'totalPage':res.data.pages
            });
            setDataList(_records);
        }else{
            setDataList([]);
        }
    }

    const goKnowledgeList = (item) => {
        console.log(item);
    }

    const turnThePage = (pageIndex) => { 
        if(pageIndex < 1 || pageIndex > pagination.totalPage){
            return false;
        }else{
            let newSearchData = {...searchData}
            newSearchData.pageIndex = pageIndex;
            setSearchData(newSearchData);
        }
    }

    const goPage = (path) => {
        window.open(path)
    }
    
    return (
        <div className="latestContent">
            <div className="LatestContentTitle">
                <div>最新内容</div>
                <div className="LatestContentMore" onClick={() => goPage("/page/knowledgeCentre")}>查看更多 <img className="rightArrowBlack" src={RightArrowBlack} alt=""/></div>
            </div>

            {pagination.pageIndex > 1 && (
                <div className="iconLeft" onClick={()=>turnThePage(pagination.pageIndex-1)}>
                    <Iconfont type={'icon-you'}/>
                </div>
            )}

            <div className="LatestContentBox">
                {dataList.map(item=>{
                    let authors = [];
                    /* 6 参考资料；7 参考研报 时没有作者，只有知识来源*/
                    if((item.knowledgeTypeId == '6' || item.knowledgeTypeId == '7' )){
                        authors = item.knowledgeSource
                    }else{
                        // 自定义作者
                        let custonAuthor = []
                        if(item.nameExts && item.nameExts.length > 0){
                            item.nameExts.map(item => {
                                custonAuthor.push(item)
                            })
                        }

                        // 作者
                        let authorsTitle = [];
                        if(item.authors){
                            item.authors.map(item=>{
                                authorsTitle.push(item)
                            })
                        }

                        if(Array.isArray(authorsTitle)){
                            authors = [...authorsTitle,...custonAuthor].toString()
                        }
                    }

                    return (
                        <div
                            key={item.knowledgeId}
                            className="LatestContentCard"
                            onClick={()=>{
                                goKnowledgeDetails({
                                    ...item,
                                    type:'home'
                                })
                            }}
                        >
                            <div className="LatestContentCardContent">
                                <div className="LatestContentCardImage">
                                    <KnowledgeFileIconV7 fileType={item.fileType}/>
                                </div>
                                <div className="LatestContentCardTitle">
                                    {item.knowledgeName}
                                </div>
                            </div>
                            <Tooltip title={item.intro} placement="topLeft">
                                <div className="LatestContentCardDescription" title={item.knowledgeDigest}>{item.knowledgeDigest}</div>
                            </Tooltip>
                            <div className="LatestContentCardFooter">
                                {item.knowledgeTypeName}
                                <Divider type="vertical" />
                                <Tooltip title={authors} placement="topLeft"> 
                                    <div className="LatestContentCardFooterAuthors">{authors}</div>
                                </Tooltip>
                                <Divider type="vertical" />
                                {item.createTime}
                                <Divider type="vertical" />
                                {item.readNum}次阅读
                            </div>
                        </div>
                    )
                })}
                <i></i><i></i>
            </div>

            {pagination.pageIndex < pagination.totalPage && (
                <div className="iconRight" onClick={()=>turnThePage(pagination.pageIndex+1)}>
                    <Iconfont type={'icon-you'}/>
                </div>
            )}
        </div>
    );
}
export default LatestContent;
